import React, {
  createContext,
  useState,
  useCallback,
  useEffect,
  useRef,
} from "react";
import indexedDBService from "../services/IndexedDBService";
import LOGOIMAGE from "../asset/nexGenBlue.gif";
import { useAlert } from "./AlertContext";

const CanvasContext = createContext();

const CanvasProvider = ({ children }) => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const [canvasDivisions, setCanvasDivisions] = useState([]);
  const [flatList, setFlatList] = useState([]);
  const [pages, setPages] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [hoveredDivision, setHoveredDivision] = useState(null);
  const [reusableComponents, setReusableComponents] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);
  const [showFileManager, setShowFileManager] = useState(false);
  const [showDemoInstructions, setShowDemoInstructions] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [LayOut, setLayOut] = useState(0);
  const [downloadProgress, setDownloadProgress] = useState({
    current: 0,
    total: 0,
    percentage: 0,
    remainingTime: 0,
  });
  const [historyStack, setHistoryStack] = useState([]);
  const [historyPointer, setHistoryPointer] = useState(-1);
  const [isUndoRedoInProgress, setIsUndoRedoInProgress] = useState(false);
  const [isUndoInProgress, setIsUndoInProgress] = useState(false);
  const [isRedoInProgress, setIsRedoInProgress] = useState(false);
  const { setAlert } = useAlert();

  const updateDownloadProgress = (progress) => {
    setDownloadProgress(progress);
  };
  const [preferences, setPreferences] = useState({
    showLeftSidebar: true,
    showRightSidebar: true,
    showLayers: true,
    showProperties: true,
    showPageManager: false,
  });
  const [showGrid, setShowGrid] = useState(() => {
    const storedShowGrid = localStorage.getItem("showGrid");
    return storedShowGrid ? JSON.parse(storedShowGrid) : false;
  });

  // fro Id/parentId/reusablecomponent Id... Generation

  // Dbugging for history stack and pointer
  useEffect(() => {
    console.log(`history Pointer`, historyPointer);
  }, [historyPointer]);

  // Function to cleare hostory (call on delete project)
  const cleareHistory = useCallback(async () => {
    try {
      await indexedDBService.clearHistoryStack();
    } catch (error) {
      alert(`Error clearing history stack`, error);
    }
  }, []);

  let globalIdCounter = useRef(0);
  const generateUniqueId = useCallback(() => {
    const newId = Math.max(Date.now(), globalIdCounter.current + 1);
    globalIdCounter.current = newId;
    return newId;
  }, []);

  const cloneWithNewIds = useCallback(
    (element, newParentId = null) => {
      if (Array.isArray(element)) {
        return element.map((item) => cloneWithNewIds(item, newParentId));
      }

      if (typeof element !== "object" || element === null) {
        return element;
      }

      const newId = generateUniqueId();
      const newElement = { ...element, id: newId, parentId: newParentId };

      for (const key in newElement) {
        if (key === "children") {
          newElement[key] = Array.isArray(element[key])
            ? element[key].map((child) => cloneWithNewIds(child, newId))
            : [];
        } else if (typeof newElement[key] === "object") {
          newElement[key] = cloneWithNewIds(newElement[key], newId);
        }
      }

      return newElement;
    },
    [generateUniqueId]
  );
  const findDivisionById = useCallback((divs, id) => {
    for (let div of divs) {
      if (div.id === id) {
        return div;
      }
      if (div.children && div.children.length > 0) {
        const found = findDivisionById(div.children, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }, []);

  //generates flat list for all dropped things in canvas
  const generateFlatList = useCallback((divs) => {
    const flatList = [];
    const flatten = (divs) => {
      divs.forEach((div) => {
        flatList.push(div);
        if (div.children && div.children.length > 0) {
          flatten(div.children);
        }
      });
    };
    flatten(divs);
    return flatList;
  }, []);
  // Function to push to history stack
  const pushToHistoryStack = useCallback(async (action) => {
    const newPointer = await indexedDBService.pushToHistoryStack(action);
    setHistoryPointer(newPointer);
    // Update local history stack
    const updatedStack = await indexedDBService.getHistoryStack();
    setHistoryStack(updatedStack);
  }, []);

  //functions to add things in Canvas
  const addCanvasDrop = (parentId = null, name, type) => {
    const parentDivision = parentId
      ? findDivisionById(canvasDivisions, parentId)
      : null;

    let newCanvasDrop = {
      id: generateUniqueId(),
      parentId,
      width: "100%",
      height: "100px",
      display: "block",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      border: "1px solid black",
      overflow: "hidden",
      padding: "8px",
      name,
      children: [],
      type,
      parentClassname: parentDivision ? parentDivision.classname : "",
    };

    if (parentId === null) {
      setCanvasDivisions((prevDivisions) => {
        const updatedDivisions = [...prevDivisions, newCanvasDrop];
        setFlatList(generateFlatList(updatedDivisions));
        indexedDBService
          .getPreference("historyLock")
          .then((result) => {
            if (!result) {
              pushToHistoryStack({
                type: "Add",
                item: newCanvasDrop,
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
        return updatedDivisions;
      });
    } else {
      setCanvasDivisions((prevDivisions) => {
        const newDivisions = [...prevDivisions];
        const parentDivision = findDivisionById(newDivisions, parentId);
        if (parentDivision) {
          parentDivision.children.push(newCanvasDrop);
          // indexedDBService
          //   .getPreference("historyLock")
          //   .then((result) => {
          //     if (!result) {
          //       pushToHistoryStack({
          //         type: "Add",
          //         item: newCanvasDrop,
          //       });
          //     }
          //   })
          //   .catch((err) => {
          //     console.error(`Error adding new division in ${parentId}`, err);
          //   });
        } else {
          console.error(`Parent division with id ${parentId} not found.`);
        }
        setFlatList(generateFlatList(newDivisions));
        return newDivisions;
      });
    }
  };

  const addDivision = (parentId = null, name, type) => {
    const parentDivision = parentId
      ? findDivisionById(canvasDivisions, parentId)
      : null;

    let newDivision = {
      id: generateUniqueId(),
      parentId,
      name,
      width: "100%",
      height: "100vh",
      padding: "8px",
      border: "1px solid #000000",
      backgroundColor: "#ffffff",
      overflow: "hidden",
      children: [],
      type,
      parentClassname: parentDivision ? parentDivision.classname : "",
    };

    if (parentId === null) {
      setCanvasDivisions((prevDivisions) => {
        const updatedDivisions = [...prevDivisions, newDivision];
        setFlatList(generateFlatList(updatedDivisions));
        indexedDBService
          .getPreference("historyLock")
          .then((result) => {
            if (!result) {
              pushToHistoryStack({
                type: "Add",
                item: newDivision,
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
        return updatedDivisions;
      });
    } else {
      setCanvasDivisions((prevDivisions) => {
        const newDivisions = [...prevDivisions];
        const parentDivision = findDivisionById(newDivisions, parentId);
        if (parentDivision) {
          parentDivision.children.push(newDivision);
          indexedDBService
            .getPreference("historyLock")
            .then((result) => {
              if (!result) {
                pushToHistoryStack({
                  type: "Add",
                  item: newDivision,
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          console.error(`Parent division with id ${parentId} not found.`);
        }
        setFlatList(generateFlatList(newDivisions));
        return newDivisions;
      });
    }
  };

  const addElement = (parentId = null, name, type) => {
    const parentDivision = parentId
      ? findDivisionById(canvasDivisions, parentId)
      : null;

    let newElement;

    if (type === "DroppableImage") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        width: "200px",
        height: "auto",
        display: "block",
        src: LOGOIMAGE,
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableVideo") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        width: "200px",
        height: "auto",
        display: "block",
        src: "...",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableAudio") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        display: "block",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableHeading" || type === "DroppableParagraph") {
      newElement = {
        text: "nexGen",
        id: generateUniqueId(),
        parentId,
        name,
        type,
        width: "100%",
        height: "50px",
        fontFamily: "Times New Roman, serif",
        fontWeight: "normal",
        fontStyle: "normal",
        margin: "0",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableButton") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        width: "100px",
        height: "30px",
        border: "1px solid #000000",
        backgroundColor: "#2b00ff",
        textAlign: "center",
        color: "#ffffff",
        paddingTop: "3px",
        paddingRight: "5px",
        paddingBottom: "3px",
        paddingLeft: "5px",
        borderRadius: "10px",
        display: "block",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableList") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        parentClassname: parentDivision ? parentDivision.classname : "",
        padding: "0",
        paddingLeft: "1.5rem",
        margin: "0",
      };
    } else if (type === "DroppableLink") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        display: "block",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableText") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        width: "100px",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableOutput") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        border: "1px solid",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else if (type === "DroppableIcon") {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        width: "100%",
        height: "auto",
        display: "block",
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    } else {
      newElement = {
        id: generateUniqueId(),
        parentId,
        name,
        type,
        parentClassname: parentDivision ? parentDivision.classname : "",
      };
    }

    if (parentId === null) {
      setCanvasDivisions((prevDivisions) => {
        const updatedDivisions = [...prevDivisions, newElement];
        indexedDBService
          .getPreference("historyLock")
          .then((result) => {
            if (!result) {
              pushToHistoryStack({
                type: "Add",
                item: newElement,
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
        setFlatList(generateFlatList(updatedDivisions));
        return updatedDivisions;
      });
    } else {
      setCanvasDivisions((prevDivisions) => {
        const newDivisions = [...prevDivisions];
        const parentDivision = findDivisionById(newDivisions, parentId);
        if (parentDivision) {
          parentDivision.children.push(newElement);
          indexedDBService
            .getPreference("historyLock")
            .then((result) => {
              if (!result) {
                pushToHistoryStack({
                  type: "Add",
                  item: newElement,
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          console.error(`Parent division with id ${parentId} not found.`);
        }
        setFlatList(generateFlatList(newDivisions));
        return newDivisions;
      });
    }
  };

  const addDivisionFromUndoRedo = useCallback(
    async (undoItem, isUndoOperation = false) => {
      if (isUndoOperation) {
        setCanvasDivisions((prevDivisions) => {
          const updatedDivisions = [...prevDivisions];
          if (undoItem.parentId === null) {
            const searchDivision = findDivisionById(
              updatedDivisions,
              undoItem.id
            );
            if (!searchDivision) updatedDivisions.push(undoItem);
          } else {
            const parentDivision = findDivisionById(
              updatedDivisions,
              undoItem.parentId
            );
            if (parentDivision) {
              const childExists = parentDivision.children.some(
                (child) => child.id === undoItem.id
              );
              if (!childExists) {
                parentDivision.children.push(undoItem);
              }
            } else {
              console.error(
                `Parent division with id ${undoItem.parentId} not found.`
              );
            }
          }

          // Update the flat list
          setFlatList(generateFlatList(updatedDivisions));
          return updatedDivisions;
        });
      }
    },
    [findDivisionById, generateFlatList]
  );

  //update Divisions or other alements
  const updateDivision = (id, updatedProps) => {
    setCanvasDivisions((prevDivisions) => {
      const updateDivisionProps = (divs) => {
        return divs.map((div) => {
          if (div.id === id) {
            let newProps = { ...div };

            // If a classname is being explicitly set or updated
            if (
              updatedProps.classname !== undefined &&
              updatedProps.classname !== div.classname
            ) {
              const existingElement = findElementWithSameClass(
                prevDivisions,
                updatedProps.classname
              );
              if (existingElement) {
                // Inherit CSS properties from the existing element
                Object.keys(existingElement).forEach((key) => {
                  if (
                    key !== "id" &&
                    key !== "Id_For_html" &&
                    key !== "parentId" &&
                    key !== "name" &&
                    key !== "type" &&
                    key !== "data" &&
                    key !== "children" &&
                    key !== "text" &&
                    key !== "src" &&
                    key !== "url" &&
                    key !== "alt" &&
                    key !== "title" &&
                    key !== "posterUrl" &&
                    key !== "poster" &&
                    key !== "lat" &&
                    key !== "lng" &&
                    key !== "zoom" &&
                    key !== "searchQuery" &&
                    key !== "items" &&
                    key !== "iconName" &&
                    key !== "href" &&
                    key !== "target" &&
                    key !== "rel" &&
                    key !== "label" &&
                    key !== "redirectTo" &&
                    key !== "level" &&
                    key !== "value" &&
                    key !== "placeholder" &&
                    key !== "for" &&
                    key !== "titleMap" &&
                    key !== "iframeCode" &&
                    key !== "classname"
                  ) {
                    // Only update if the property isn't explicitly set in updatedProps
                    if (updatedProps[key] === undefined) {
                      newProps[key] = existingElement[key];
                    }
                  }
                });
              }
              newProps.classname = updatedProps.classname;
            }

            // Apply all other updated properties
            Object.keys(updatedProps).forEach((key) => {
              if (key !== "classname" || updatedProps.classname !== undefined) {
                newProps[key] = updatedProps[key];
              }
            });

            // Update children with the new classname if it has changed
            if (updatedProps.classname !== undefined && newProps.children) {
              newProps.children = updateChildClassname(
                newProps.children,
                newProps.classname
              );
            }

            indexedDBService
              .getPreference("historyLock")
              .then((result) => {
                if (!result) {
                  pushToHistoryStack({
                    type: "Update",
                    oldItem: div,
                    newItem: newProps,
                  });
                }
              })
              .catch((err) => {
                console.error(err);
              });
            return newProps;
          }
          if (div.children && div.children.length > 0) {
            return { ...div, children: updateDivisionProps(div.children) };
          }
          return div;
        });
      };

      const updateChildClassname = (children, parentClassname) => {
        if (!children) return []; // Return an empty array if children is undefined
        return children.map((child) => {
          const updatedChild = { ...child, parentClassname: parentClassname };
          if (child.children && child.children.length > 0) {
            updatedChild.children = updateChildClassname(
              child.children,
              parentClassname
            );
          }
          return updatedChild;
        });
      };

      const updatedDivisions = updateDivisionProps(prevDivisions);
      setFlatList(generateFlatList(updatedDivisions));
      return updatedDivisions;
    });
  };

  // Function to update components from undoRedo
  const updateDivisionFromUndoRedo = useCallback(
    (id, updatedProps) => {
      setCanvasDivisions((prevDivisions) => {
        const updateDivisionProps = (divs) => {
          return divs.map((div) => {
            if (div.id === id) {
              // This is division to be update
              const newProps = { ...div, ...updatedProps };
              if (updatedProps.classname !== undefined) {
                newProps.classname = updatedProps.classname;
              }
              // Update children with the new classname if they exist
              if (newProps.classname !== undefined && newProps.children) {
                newProps.children = updateChildClassname(
                  newProps.children,
                  newProps.classname
                );
              }

              return newProps;
            }
            if (div.children && div.children.length > 0) {
              return { ...div, children: updateDivisionProps(div.children) };
            }
            return div;
          });
        };

        const updateChildClassname = (children, parentClassname) => {
          if (!children) return []; // Return an empty array if children is undefined
          return children.map((child) => {
            const updatedChild = { ...child, parentClassname: parentClassname };
            if (child.children && child.children.length > 0) {
              updatedChild.children = updateChildClassname(
                child.children,
                parentClassname
              );
            }
            return updatedChild;
          });
        };

        const updatedDivisions = updateDivisionProps(prevDivisions);
        setFlatList(generateFlatList(updatedDivisions));
        return updatedDivisions;
      });
    },
    [generateFlatList]
  );

  // Delete Divisions or other alements
  const deleteDivision = useCallback(
    (id) => {
      const deleteRecursive = (divs, idToDelete) => {
        return divs.filter((div) => {
          if (div.id === idToDelete) return false;
          if (div.children && div.children.length > 0) {
            div.children = deleteRecursive(div.children, idToDelete);
          }
          return true;
        });
      };

      setCanvasDivisions((prevDivisions) => {
        const updatedDivisions = deleteRecursive(prevDivisions, id);
        const newFlatList = generateFlatList(updatedDivisions);
        setFlatList(newFlatList);

        // Update the global counter to the highest ID in use
        if (newFlatList.length > 0) {
          globalIdCounter.current = Math.max(
            ...newFlatList.map((item) => item.id),
            globalIdCounter.current
          );
        }
        return updatedDivisions;
      });
    },
    [generateFlatList]
  );

  //to inherit css for same class name
  const findElementWithSameClass = (divisions, className) => {
    for (let div of divisions) {
      if (div.classname === className) {
        return div;
      }
      if (div.children && div.children.length > 0) {
        const found = findElementWithSameClass(div.children, className);
        if (found) return found;
      }
    }
    return null;
  };

  //to rename Classnane and Id of layers
  const renameDivision = (id, newClassname) => {
    updateDivision(id, { classname: newClassname });
  };
  const giveIdToDivision = (id, newID) => {
    updateDivision(id, { Id_For_html: newID });
  };

  //fucntion that will call when Deletion of project happens
  const handleDeleteProject = async () => {
    setCanvasDivisions([]);
    setFlatList([]);
    setPages([]);
    setCurrentPage(null);
    globalIdCounter.current = 0;
    await indexedDBService.clearAllPages();
    await indexedDBService.deleteAllFiles();
    await cleareHistory();
    window.location.reload();
  };
  //function that will call when creation of new project happens
  const createNewProject = async (shouldExport) => {
    if (shouldExport) {
      // console.log("Exporting current project...");
    }

    setCanvasDivisions([]);
    setFlatList([]);
    setSelectedDivision(null);
    setHoveredDivision(null);
    globalIdCounter.current = 0;

    setPages([]);
    setCurrentPage(null);

    await indexedDBService.clearAllPages();
    window.location.reload();
  };

  //for all reusable component functionality
  const validTypes = [
    "DroppableDiv",
    "DroppableNav",
    "DroppableHeader",
    "DroppableHGroup",
    "DroppableFooter",
    "DroppableSection",
    "DroppableSpan",
    "DroppableForm",
    "DroppableMain",
    "DroppableArticle",
    "DroppableAside",
  ];
  const addReusableComponent = useCallback(
    async (component) => {
      const newId = Date.now();
      const newComponent = { ...component, id: newId, isReusable: true };
      const updatedComponents = [...reusableComponents, newComponent];
      setReusableComponents(updatedComponents);
      await indexedDBService.saveReusableComponent(newComponent);

      // Update globalIdCounter if necessary
      if (newId > globalIdCounter.current) {
        globalIdCounter.current = newId;
      }
    },
    [reusableComponents]
  );
  const deleteReusableComponent = useCallback(
    async (componentId) => {
      const updatedComponents = reusableComponents.filter(
        (comp) => comp.id !== componentId
      );
      setReusableComponents(updatedComponents);
      await indexedDBService.deleteReusableComponent(componentId);
    },
    [reusableComponents]
  );
  const loadReusableComponents = useCallback(async () => {
    const savedComponents = await indexedDBService.getReusableComponents();
    if (savedComponents && savedComponents.length > 0) {
      setReusableComponents(savedComponents);
    }
  }, []);
  const makeReusable = useCallback(
    (division) => {
      if (validTypes.includes(division.type)) {
        const reusableComponent = {
          ...JSON.parse(JSON.stringify(division)),
          id: Date.now(),
          isReusable: true,
        };
        addReusableComponent(reusableComponent);
      } else {
        alert("This type cannot be made reusable.");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addReusableComponent]
  );
  const applyReusableComponent = useCallback(
    (component, parentId = null) => {
      const newComponent = cloneWithNewIds(component, parentId);

      setCanvasDivisions((prevDivisions) => {
        let updatedDivisions;
        if (parentId === null) {
          updatedDivisions = [...prevDivisions, newComponent];
          indexedDBService
            .getPreference("historyLock")
            .then((result) => {
              if (!result) {
                pushToHistoryStack({
                  type: "Add",
                  item: newComponent,
                });
              }
            })
            .catch((err) => {
              console.error(`Error adding new division in ${parentId}`, err);
            });
        } else {
          updatedDivisions = prevDivisions.map((div) => {
            if (div.id === parentId) {
              indexedDBService
                .getPreference("historyLock")
                .then((result) => {
                  if (!result) {
                    pushToHistoryStack({
                      type: "Add",
                      item: newComponent,
                    });
                  }
                })
                .catch((err) => {
                  console.error(
                    `Error adding new division in ${parentId}`,
                    err
                  );
                });
              return {
                ...div,
                children: [...(div.children || []), newComponent],
              };
            }
            return div;
          });
        }

        const newFlatList = generateFlatList(updatedDivisions);
        setFlatList(newFlatList);

        // Update globalIdCounter
        const allIds = newFlatList.map((item) => item.id);
        globalIdCounter.current = Math.max(...allIds, globalIdCounter.current);

        return updatedDivisions;
      });
    },
    [cloneWithNewIds, generateFlatList, pushToHistoryStack]
  );
  const renameReusableComponent = useCallback(
    async (componentId, newName) => {
      const updatedComponents = reusableComponents.map((component) =>
        component.id === componentId
          ? { ...component, name: newName }
          : component
      );
      setReusableComponents(updatedComponents);

      // Find the updated component
      const updatedComponent = updatedComponents.find(
        (comp) => comp.id === componentId
      );

      // Save the updated component to IndexedDB
      if (updatedComponent) {
        await indexedDBService.updateReusableComponent(updatedComponent);
      }
    },
    [reusableComponents]
  );
  useEffect(() => {
    loadReusableComponents();
  }, [loadReusableComponents]);

  //to load Demo page if current page is Demo
  useEffect(() => {
    if (currentPage && currentPage.name === "Demo") {
      setShowDemoInstructions(true);
    } else {
      setShowDemoInstructions(false);
    }
  }, [currentPage]);

  //to load and save canvasDivisions
  const loadCanvasDivisions = useCallback(async () => {
    if (currentPage) {
      try {
        const savedDivisions = await indexedDBService.getCanvasDivisions(
          currentPage.id
        );
        if (savedDivisions && savedDivisions.length > 0) {
          setCanvasDivisions(savedDivisions);
          setFlatList(generateFlatList(savedDivisions));
          const allElements = savedDivisions.flatMap((div) =>
            div.children ? [div, ...div.children] : [div]
          );
          globalIdCounter.current =
            Math.max(
              ...allElements.map((el) => el.id),
              globalIdCounter.current
            ) + 1;
        } else {
          setCanvasDivisions([]);
          setFlatList([]);
          // Don't reset globalIdCounter here
        }
      } catch (error) {
        console.error("Error loading canvas divisions:", error);
      }
    }
  }, [currentPage, generateFlatList]);
  const saveCanvasDivisions = useCallback(async () => {
    if (currentPage && canvasDivisions.length > 0) {
      try {
        await indexedDBService.saveCanvasDivisions(
          currentPage.id,
          canvasDivisions
        );
      } catch (error) {
        console.error("Error saving canvas divisions:", error);
      }
    }
  }, [canvasDivisions, currentPage]);
  useEffect(() => {
    loadCanvasDivisions();
  }, [loadCanvasDivisions]);
  useEffect(() => {
    const saveTimer = setTimeout(() => {
      saveCanvasDivisions();
    }, 500);
    return () => clearTimeout(saveTimer);
  }, [canvasDivisions, saveCanvasDivisions]);

  //to load and save pages
  const loadPages = useCallback(async () => {
    let savedPages = await indexedDBService.getPages();
    if (savedPages && savedPages.length > 0) {
      setPages(savedPages);

      const lastActivePageId = localStorage.getItem("lastActivePageId");
      if (lastActivePageId) {
        const lastActivePage = savedPages.find(
          (page) => page.id.toString() === lastActivePageId
        );
        if (lastActivePage) {
          setCurrentPage(lastActivePage);
          return;
        }
      }
      setCurrentPage(savedPages[0]);
    } else {
      const defaultPage = { id: Date.now(), name: "Demo" };
      setPages([defaultPage]);
      setCurrentPage(defaultPage);
      await indexedDBService.savePage(defaultPage);
    }
  }, []);
  const setAndPersistCurrentPage = useCallback((page) => {
    setCurrentPage(page);
    localStorage.setItem("lastActivePageId", page.id.toString());
  }, []);

  // to load and save preferences(open components and layout options)
  const loadPreferences = useCallback(async () => {
    const loadedPrefs = {};
    for (const key of [
      ...Object.keys(preferences),
      "LayOut",
      "isDarkTheme",
      "historyPointer",
    ]) {
      const value = await indexedDBService.getPreference(key);
      if (key === "LayOut") {
        setLayOut(value !== null ? value : 0);
      } else if (key === "isDarkTheme") {
        setIsDarkTheme(value !== null ? value : false);
      } else if (key === "historyPointer") {
        setHistoryPointer(value !== null ? value : -1);
      } else {
        loadedPrefs[key] = value !== null ? value : preferences[key];
      }
    }
    setPreferences(loadedPrefs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const savePreference = useCallback(async (key, value) => {
    await indexedDBService.savePreference(key, value);
    if (key === "isDarkTheme") {
      setIsDarkTheme(value);
    } else {
      setPreferences((prev) => ({ ...prev, [key]: value }));
    }
  }, []);
  const saveLayOut = useCallback(async (value) => {
    await indexedDBService.savePreference("LayOut", value);
    setLayOut(value);
  }, []);
  useEffect(() => {
    localStorage.setItem("showGrid", JSON.stringify(showGrid));
  }, [showGrid]);

  //useEffect for pages loading and preference loading
  useEffect(() => {
    loadPages();
    loadPreferences();
  }, [loadPages, loadPreferences]);

  //add and delete page functions
  const addPage = async (pageName) => {
    const newPage = { id: Date.now(), name: pageName };
    const updatedPages = [...pages, newPage];
    setPages(updatedPages);
    await indexedDBService.savePage(newPage);
  };
  const deletePage = async (pageId) => {
    if (pages.length > 1) {
      const updatedPages = pages.filter((page) => page.id !== pageId);
      setPages(updatedPages);
      if (currentPage.id === pageId) {
        setCurrentPage(updatedPages[0]);
      }
      await indexedDBService.deletePage(pageId);
    }
  };

  //for dark/light theme
  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkTheme ? "dark" : "light"
    );
    document.body.classList.toggle("dark-theme", isDarkTheme);
  }, [isDarkTheme]);

  //to rearrange the items
  const reorderDivision = useCallback(
    (id, direction) => {
      setCanvasDivisions((prevDivisions) => {
        const reorderRecursive = (divs) => {
          for (let i = 0; i < divs.length; i++) {
            if (divs[i].id === id) {
              if (direction === "up" && i > 0) {
                [divs[i - 1], divs[i]] = [divs[i], divs[i - 1]];
                return true;
              } else if (direction === "down" && i < divs.length - 1) {
                [divs[i], divs[i + 1]] = [divs[i + 1], divs[i]];
                return true;
              }
              return false;
            }
            if (divs[i].children && divs[i].children.length > 0) {
              if (reorderRecursive(divs[i].children)) {
                return true;
              }
            }
          }
          return false;
        };

        const newDivisions = JSON.parse(JSON.stringify(prevDivisions));
        reorderRecursive(newDivisions);

        // Update flatList
        const newFlatList = generateFlatList(newDivisions);
        setFlatList(newFlatList);

        return newDivisions;
      });
    },
    [generateFlatList, setFlatList]
  );

  // Function to perform undo
  const undo = useCallback(async () => {
    if (historyPointer <= -1) {
      setAlert({
        title: "can't undo",
        message: "No task to undo",
        variant: "warn",
        duration: 1000,
      });
      return;
    }
    const history = await indexedDBService.getHistoryStack();
    if (historyPointer >= 0) {
      await savePreference("historyLock", true);
      const action = await history[historyPointer];
      if (action.type === "Add") {
        try {
          deleteDivision(action.item.id, true);
        } catch (error) {
          alert(`Error deleting for undo`, error);
        }
      } else if (action.type === "Remove") {
        try {
          addDivisionFromUndoRedo(action.item, true);
        } catch (error) {
          alert(`Error adding for undo`, error);
        }
      } else if (action.type === "Update") {
        try {
          updateDivisionFromUndoRedo(action.oldItem.id, action.oldItem);
          // updateDivision(action.oldItem.id, null, action.oldItem, true);
        } catch (error) {
          alert(`Error updating for undo`, error);
        }
      }
      const newPointer = historyPointer - 1;
      await indexedDBService.setHistoryPointer(newPointer);
      setHistoryPointer(newPointer);
      await savePreference("historyLock", false);
    }
  }, [
    historyPointer,
    setAlert,
    savePreference,
    deleteDivision,
    addDivisionFromUndoRedo,
    updateDivisionFromUndoRedo,
  ]);

  // Function to perform redo
  const redo = useCallback(async () => {
    const history = await indexedDBService.getHistoryStack();
    if (historyPointer === history.length - 1) {
      setAlert({
        title: "can't redo",
        message: "No task to redo",
        variant: "warn",
        duration: 1000,
      });
      return;
    }
    if (historyPointer < history.length - 1) {
      await savePreference("historyLock", true);
      const newPointer = historyPointer + 1;
      await indexedDBService.setHistoryPointer(newPointer);
      setHistoryPointer(newPointer);

      const action = await history[newPointer];
      // Perform the action
      if (action.type === "Add") {
        try {
          addDivisionFromUndoRedo(action.item, true);
        } catch (error) {
          alert(`Error adding for redo`, error);
        }
      } else if (action.type === "Remove") {
        try {
          deleteDivision(action.item.id, true);
        } catch (error) {
          alert(`Error deleting for redo`, error);
        }
      } else if (action.type === "Update") {
        try {
          updateDivisionFromUndoRedo(action.newItem.id, action.newItem);
        } catch (error) {
          alert(`Error updating for redo`, error);
        }
      }

      await savePreference("historyLock", false);
    }
  }, [
    historyPointer,
    setAlert,
    savePreference,
    addDivisionFromUndoRedo,
    deleteDivision,
    updateDivisionFromUndoRedo,
  ]);

  // Load history stack and pointer on initial load
  useEffect(() => {
    const loadHistory = async () => {
      const stack = await indexedDBService.getHistoryStack();
      const pointer = await indexedDBService.getHistoryPointer();
      await indexedDBService.savePreference("historyLock", false);
      setHistoryStack(stack);
      setHistoryPointer(pointer);
    };
    loadHistory();
  }, []);

  // Function to process the undo/redo operation Queue
  const processUndoRedoQueue = useCallback(async () => {
    try {
      const operation = await indexedDBService.getNextUndoRedoOperation();
      if (!operation) {
        await indexedDBService.setUndoRedoLock(false);
        return;
      }

      const isLocked = await indexedDBService.getUndoRedoLock();
      if (isLocked) return;

      await indexedDBService.setUndoRedoLock(true);
      setIsUndoRedoInProgress(true);

      if (operation) {
        if (operation.type === "undo") {
          setIsUndoInProgress(true);
          await undo();
        } else if (operation.type === "redo") {
          setIsRedoInProgress(true);
          await redo();
        }
      }
    } catch (error) {
      console.error("Error processing undo/redo operation:", error);
    } finally {
      setIsUndoRedoInProgress(false);
      setIsUndoInProgress(false);
      setIsRedoInProgress(false);
      await indexedDBService.setUndoRedoLock(false);
    }
  }, [undo, redo]);

  useEffect(() => {
    const intervalId = setInterval(processUndoRedoQueue, 100);
    return () => clearInterval(intervalId);
  }, [processUndoRedoQueue]);

  // Function that Queue the undo/redo operation
  const queueUndoRedoOperation = useCallback(async (operationType) => {
    await indexedDBService.pushToUndoRedoQueue({ type: operationType });
  }, []);

  return (
    <CanvasContext.Provider
      value={{
        isDarkTheme,
        setIsDarkTheme: (value) => savePreference("isDarkTheme", value),
        canvasDivisions,
        reloadCanvasDivisions: loadCanvasDivisions,
        addDivision,
        addElement,
        generateFlatList,
        addCanvasDrop,
        selectedDivision,
        setSelectedDivision,
        flatList,
        setFlatList,
        hoveredDivision,
        setHoveredDivision,
        deleteDivision,
        updateDivision,
        renameDivision,
        giveIdToDivision,
        currentPage,
        setCurrentPage: setAndPersistCurrentPage,
        pages,
        showFileManager,
        setShowFileManager,
        setPages,
        addPage,
        deletePage,
        createNewProject,
        showDemoInstructions,
        setShowDemoInstructions,
        handleDeleteProject,
        ...preferences,
        setShowLeftSidebar: (value) => savePreference("showLeftSidebar", value),
        setShowRightSidebar: (value) =>
          savePreference("showRightSidebar", value),
        setShowLayers: (value) => savePreference("showLayers", value),
        setShowProperties: (value) => savePreference("showProperties", value),
        setShowPageManager: (value) => savePreference("showPageManager", value),
        LayOut,
        setLayOut: saveLayOut,
        showGrid,
        setShowGrid,
        setFiles,
        files,
        isDownloading,
        setIsDownloading,
        downloadProgress,
        updateDownloadProgress,
        reusableComponents,
        addReusableComponent,
        deleteReusableComponent,
        makeReusable,
        applyReusableComponent,
        renameReusableComponent,
        reorderDivision,
        undo,
        canUndo: historyPointer >= 0,
        redo,
        canRedo: historyPointer < historyStack.length - 1,
        queueUndoRedoOperation,
        isUndoRedoInProgress,
        isUndoInProgress,
        isRedoInProgress,
      }}
    >
      {children}
    </CanvasContext.Provider>
  );
};

export { CanvasContext, CanvasProvider };

// import React, {
//   createContext,
//   useState,
//   useCallback,
//   useEffect,
//   useRef,
// } from "react";
// import indexedDBService from "../services/IndexedDBService";
// import LOGOIMAGE from "../asset/nexGenBlue.gif";

// const CanvasContext = createContext();

// const CanvasProvider = ({ children }) => {
//   const [isDarkTheme, setIsDarkTheme] = useState(false);
//   const [canvasDivisions, setCanvasDivisions] = useState([]);
//   const [flatList, setFlatList] = useState([]);
//   const [pages, setPages] = useState([]);
//   const [files, setFiles] = useState([]);
//   const [selectedDivision, setSelectedDivision] = useState(null);
//   const [hoveredDivision, setHoveredDivision] = useState(null);
//   const [reusableComponents, setReusableComponents] = useState([]);
//   const [currentPage, setCurrentPage] = useState(null);
//   const [showFileManager, setShowFileManager] = useState(false);
//   const [showDemoInstructions, setShowDemoInstructions] = useState(false);
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [LayOut, setLayOut] = useState(0);
//   const [downloadProgress, setDownloadProgress] = useState({
//     current: 0,
//     total: 0,
//     percentage: 0,
//     remainingTime: 0,
//   });
//   const updateDownloadProgress = (progress) => {
//     setDownloadProgress(progress);
//   };
//   const [preferences, setPreferences] = useState({
//     showLeftSidebar: true,
//     showRightSidebar: true,
//     showLayers: true,
//     showProperties: true,
//     showPageManager: false,
//   });
//   const [showGrid, setShowGrid] = useState(() => {
//     const storedShowGrid = localStorage.getItem("showGrid");
//     return storedShowGrid ? JSON.parse(storedShowGrid) : false;
//   });

//   // fro Id/parentId/reusablecomponent Id... Generation
//   let globalIdCounter = useRef(0);
//   const generateUniqueId = useCallback(() => {
//     const newId = Math.max(Date.now(), globalIdCounter.current + 1);
//     globalIdCounter.current = newId;
//     return newId;
//   }, []);
//   const cloneWithNewIds = useCallback(
//     (element, newParentId = null) => {
//       if (Array.isArray(element)) {
//         return element.map((item) => cloneWithNewIds(item, newParentId));
//       }

//       if (typeof element !== "object" || element === null) {
//         return element;
//       }

//       const newId = generateUniqueId();
//       const newElement = { ...element, id: newId, parentId: newParentId };

//       for (const key in newElement) {
//         if (key === "children") {
//           newElement[key] = Array.isArray(element[key])
//             ? element[key].map((child) => cloneWithNewIds(child, newId))
//             : [];
//         } else if (typeof newElement[key] === "object") {
//           newElement[key] = cloneWithNewIds(newElement[key], newId);
//         }
//       }

//       return newElement;
//     },
//     [generateUniqueId]
//   );
//   const findDivisionById = useCallback((divs, id) => {
//     for (let div of divs) {
//       if (div.id === id) {
//         return div;
//       }
//       if (div.children && div.children.length > 0) {
//         const found = findDivisionById(div.children, id);
//         if (found) {
//           return found;
//         }
//       }
//     }
//     return null;
//   }, []);

//   //functions to add things in Canvas
//   const addCanvasDrop = (parentId = null, name, type) => {
//     const parentDivision = parentId
//       ? findDivisionById(canvasDivisions, parentId)
//       : null;

//     let newCanvasDrop = {
//       id: generateUniqueId(),
//       parentId,
//       width: "100%",
//       height: "100px",
//       display: "block",
//       backgroundColor: "#ffffff",
//       borderRadius: "10px",
//       border: "1px solid black",
//       overflow: "hidden",
//       padding: "8px",
//       name,
//       children: [],
//       type,
//       parentClassname: parentDivision ? parentDivision.classname : "",
//     };

//     if (parentId === null) {
//       setCanvasDivisions((prevDivisions) => {
//         const updatedDivisions = [...prevDivisions, newCanvasDrop];
//         setFlatList(generateFlatList(updatedDivisions));
//         return updatedDivisions;
//       });
//     } else {
//       setCanvasDivisions((prevDivisions) => {
//         const newDivisions = [...prevDivisions];
//         const parentDivision = findDivisionById(newDivisions, parentId);
//         if (parentDivision) {
//           parentDivision.children.push(newCanvasDrop);
//         } else {
//           console.error(`Parent division with id ${parentId} not found.`);
//         }
//         setFlatList(generateFlatList(newDivisions));
//         return newDivisions;
//       });
//     }
//   };
//   const addDivision = (parentId = null, name, type) => {
//     const parentDivision = parentId
//       ? findDivisionById(canvasDivisions, parentId)
//       : null;

//     let newDivision = {
//       id: generateUniqueId(),
//       parentId,
//       name,
//       width: "100%",
//       height: "100vh",
//       padding: "8px",
//       border: "1px solid #000000",
//       backgroundColor: "#ffffff",
//       overflow: "hidden",
//       children: [],
//       type,
//       parentClassname: parentDivision ? parentDivision.classname : "",
//     };

//     if (parentId === null) {
//       setCanvasDivisions((prevDivisions) => {
//         const updatedDivisions = [...prevDivisions, newDivision];
//         setFlatList(generateFlatList(updatedDivisions));
//         return updatedDivisions;
//       });
//     } else {
//       setCanvasDivisions((prevDivisions) => {
//         const newDivisions = [...prevDivisions];
//         const parentDivision = findDivisionById(newDivisions, parentId);
//         if (parentDivision) {
//           parentDivision.children.push(newDivision);
//         } else {
//           console.error(`Parent division with id ${parentId} not found.`);
//         }
//         setFlatList(generateFlatList(newDivisions));
//         return newDivisions;
//       });
//     }
//   };
//   const addElement = (parentId = null, name, type) => {
//     const parentDivision = parentId
//       ? findDivisionById(canvasDivisions, parentId)
//       : null;

//     let newElement;

//     if (type === "DroppableImage") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         width: "200px",
//         height: "auto",
//         display: "block",
//         src: LOGOIMAGE,
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableVideo") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         width: "200px",
//         height: "auto",
//         display: "block",
//         src: "...",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableAudio") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         display: "block",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableHeading" || type === "DroppableParagraph") {
//       newElement = {
//         text: "nexGen",
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         width: "100%",
//         height: "50px",
//         fontFamily: "Times New Roman, serif",
//         fontWeight: "normal",
//         fontStyle: "normal",
//         margin:"0",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableButton") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         width: "100px",
//         height: "30px",
//         border: "1px solid #000000",
//         backgroundColor: "#2b00ff",
//         textAlign: "center",
//         color: "#ffffff",
//         paddingTop: "3px",
//         paddingRight: "5px",
//         paddingBottom: "3px",
//         paddingLeft: "5px",
//         borderRadius: "10px",
//         display: "block",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableList") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         parentClassname: parentDivision ? parentDivision.classname : "",
//         padding: "0",
//         paddingLeft: "1.5rem",
//         margin: "0",
//       };
//     } else if (type === "DroppableLink") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         display: "block",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableText") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         width: "100px",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableOutput") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         border: "1px solid",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else if (type === "DroppableIcon") {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         width: "100%",
//         height: "auto",
//         display: "block",
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     } else {
//       newElement = {
//         id: generateUniqueId(),
//         parentId,
//         name,
//         type,
//         parentClassname: parentDivision ? parentDivision.classname : "",
//       };
//     }

//     if (parentId === null) {
//       setCanvasDivisions((prevDivisions) => {
//         const updatedDivisions = [...prevDivisions, newElement];
//         setFlatList(generateFlatList(updatedDivisions));
//         return updatedDivisions;
//       });
//     } else {
//       setCanvasDivisions((prevDivisions) => {
//         const newDivisions = [...prevDivisions];
//         const parentDivision = findDivisionById(newDivisions, parentId);
//         if (parentDivision) {
//           parentDivision.children.push(newElement);
//         } else {
//           console.error(`Parent division with id ${parentId} not found.`);
//         }
//         setFlatList(generateFlatList(newDivisions));
//         return newDivisions;
//       });
//     }
//   };

//   //generates flat list for all dropped things in canvas
//   const generateFlatList = useCallback((divs) => {
//     const flatList = [];
//     const flatten = (divs) => {
//       divs.forEach((div) => {
//         flatList.push(div);
//         if (div.children && div.children.length > 0) {
//           flatten(div.children);
//         }
//       });
//     };
//     flatten(divs);
//     return flatList;
//   }, []);

//   //update and Delete Divisions or other alements
//   const updateDivision = (id, updatedProps) => {
//     setCanvasDivisions((prevDivisions) => {
//       const updateDivisionProps = (divs) => {
//         return divs.map((div) => {
//           if (div.id === id) {
//             let newProps = { ...div };

//             // If a classname is being explicitly set or updated
//             if (
//               updatedProps.classname !== undefined &&
//               updatedProps.classname !== div.classname
//             ) {
//               const existingElement = findElementWithSameClass(
//                 prevDivisions,
//                 updatedProps.classname
//               );
//               if (existingElement) {
//                 // Inherit CSS properties from the existing element
//                 Object.keys(existingElement).forEach((key) => {
//                   if (
//                     key !== "id" &&
//                     key !== "Id_For_html" &&
//                     key !== "parentId" &&
//                     key !== "name" &&
//                     key !== "type" &&
//                     key !== "data" &&
//                     key !== "children" &&
//                     key !== "text" &&
//                     key !== "src" &&
//                     key !== "url" &&
//                     key !== "alt" &&
//                     key !== "title" &&
//                     key !== "posterUrl" &&
//                     key !== "poster" &&
//                     key !== "lat" &&
//                     key !== "lng" &&
//                     key !== "zoom" &&
//                     key !== "searchQuery" &&
//                     key !== "items" &&
//                     key !== "iconName" &&
//                     key !== "href" &&
//                     key !== "target" &&
//                     key !== "rel" &&
//                     key !== "label" &&
//                     key !== "redirectTo" &&
//                     key !== "level" &&
//                     key !== "value" &&
//                     key !== "placeholder" &&
//                     key !== "for" &&
//                     key !== "titleMap" &&
//                     key !== "iframeCode" &&
//                     key !== "classname"
//                   ) {
//                     // Only update if the property isn't explicitly set in updatedProps
//                     if (updatedProps[key] === undefined) {
//                       newProps[key] = existingElement[key];
//                     }
//                   }
//                 });
//               }
//               newProps.classname = updatedProps.classname;
//             }

//             // Apply all other updated properties
//             Object.keys(updatedProps).forEach((key) => {
//               if (key !== "classname" || updatedProps.classname !== undefined) {
//                 newProps[key] = updatedProps[key];
//               }
//             });

//             // Update children with the new classname if it has changed
//             if (updatedProps.classname !== undefined && newProps.children) {
//               newProps.children = updateChildClassname(
//                 newProps.children,
//                 newProps.classname
//               );
//             }
//             return newProps;
//           }
//           if (div.children && div.children.length > 0) {
//             return { ...div, children: updateDivisionProps(div.children) };
//           }
//           return div;
//         });
//       };

//       const updateChildClassname = (children, parentClassname) => {
//         if (!children) return []; // Return an empty array if children is undefined
//         return children.map((child) => {
//           const updatedChild = { ...child, parentClassname: parentClassname };
//           if (child.children && child.children.length > 0) {
//             updatedChild.children = updateChildClassname(
//               child.children,
//               parentClassname
//             );
//           }
//           return updatedChild;
//         });
//       };

//       const updatedDivisions = updateDivisionProps(prevDivisions);
//       setFlatList(generateFlatList(updatedDivisions));
//       return updatedDivisions;
//     });
//   };
//   const deleteDivision = useCallback(
//     (id) => {
//       const deleteRecursive = (divs, idToDelete) => {
//         return divs.filter((div) => {
//           if (div.id === idToDelete) return false;
//           if (div.children && div.children.length > 0) {
//             div.children = deleteRecursive(div.children, idToDelete);
//           }
//           return true;
//         });
//       };

//       setCanvasDivisions((prevDivisions) => {
//         const updatedDivisions = deleteRecursive(prevDivisions, id);
//         const newFlatList = generateFlatList(updatedDivisions);
//         setFlatList(newFlatList);

//         // Update the global counter to the highest ID in use
//         if (newFlatList.length > 0) {
//           globalIdCounter.current = Math.max(
//             ...newFlatList.map((item) => item.id),
//             globalIdCounter.current
//           );
//         }
//         return updatedDivisions;
//       });
//     },
//     [generateFlatList]
//   );
//   //to inherit css for same class name
//   const findElementWithSameClass = (divisions, className) => {
//     for (let div of divisions) {
//       if (div.classname === className) {
//         return div;
//       }
//       if (div.children && div.children.length > 0) {
//         const found = findElementWithSameClass(div.children, className);
//         if (found) return found;
//       }
//     }
//     return null;
//   };

//   //to rename Classnane and Id of layers
//   const renameDivision = (id, newClassname) => {
//     updateDivision(id, { classname: newClassname });
//   };
//   const giveIdToDivision = (id, newID) => {
//     updateDivision(id, { Id_For_html: newID });
//   };

//   //fucntion that will call when Deletion of project happens
//   const handleDeleteProject = async () => {
//     setCanvasDivisions([]);
//     setFlatList([]);
//     setPages([]);
//     setCurrentPage(null);
//     globalIdCounter.current = 0;
//     await indexedDBService.clearAllPages();
//     await indexedDBService.deleteAllFiles();

//     window.location.reload();
//   };
//   //function that will call when creation of new project happens
//   const createNewProject = async (shouldExport) => {
//     if (shouldExport) {
//       console.log("Exporting current project...");
//     }

//     setCanvasDivisions([]);
//     setFlatList([]);
//     setSelectedDivision(null);
//     setHoveredDivision(null);
//     globalIdCounter.current = 0;

//     setPages([]);
//     setCurrentPage(null);

//     await indexedDBService.clearAllPages();
//     window.location.reload();
//   };

//   //for all reusable component functionality
//   const validTypes = [
//     "DroppableDiv",
//     "DroppableNav",
//     "DroppableHeader",
//     "DroppableHGroup",
//     "DroppableFooter",
//     "DroppableSection",
//     "DroppableSpan",
//     "DroppableForm",
//     "DroppableMain",
//     "DroppableArticle",
//     "DroppableAside",
//   ];
//   const addReusableComponent = useCallback(
//     async (component) => {
//       const newId = Date.now();
//       const newComponent = { ...component, id: newId, isReusable: true };
//       const updatedComponents = [...reusableComponents, newComponent];
//       setReusableComponents(updatedComponents);
//       await indexedDBService.saveReusableComponent(newComponent);

//       // Update globalIdCounter if necessary
//       if (newId > globalIdCounter.current) {
//         globalIdCounter.current = newId;
//       }
//     },
//     [reusableComponents]
//   );
//   const deleteReusableComponent = useCallback(
//     async (componentId) => {
//       const updatedComponents = reusableComponents.filter(
//         (comp) => comp.id !== componentId
//       );
//       setReusableComponents(updatedComponents);
//       await indexedDBService.deleteReusableComponent(componentId);
//     },
//     [reusableComponents]
//   );
//   const loadReusableComponents = useCallback(async () => {
//     const savedComponents = await indexedDBService.getReusableComponents();
//     if (savedComponents && savedComponents.length > 0) {
//       setReusableComponents(savedComponents);
//     }
//   }, []);
//   const makeReusable = useCallback(
//     (division) => {
//       if (validTypes.includes(division.type)) {
//         const reusableComponent = {
//           ...JSON.parse(JSON.stringify(division)),
//           id: Date.now(),
//           isReusable: true,
//         };
//         addReusableComponent(reusableComponent);
//       } else {
//         alert("This type cannot be made reusable.");
//       }
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [addReusableComponent]
//   );
//   const applyReusableComponent = useCallback(
//     (component, parentId = null) => {
//       const newComponent = cloneWithNewIds(component, parentId);

//       setCanvasDivisions((prevDivisions) => {
//         let updatedDivisions;
//         if (parentId === null) {
//           updatedDivisions = [...prevDivisions, newComponent];
//         } else {
//           updatedDivisions = prevDivisions.map((div) => {
//             if (div.id === parentId) {
//               return {
//                 ...div,
//                 children: [...(div.children || []), newComponent],
//               };
//             }
//             return div;
//           });
//         }

//         const newFlatList = generateFlatList(updatedDivisions);
//         setFlatList(newFlatList);

//         // Update globalIdCounter
//         const allIds = newFlatList.map((item) => item.id);
//         globalIdCounter.current = Math.max(...allIds, globalIdCounter.current);

//         return updatedDivisions;
//       });

//       console.log("Applied reusable component:", newComponent);
//     },
//     [setCanvasDivisions, setFlatList, generateFlatList, cloneWithNewIds]
//   );
//   const renameReusableComponent = useCallback(
//     async (componentId, newName) => {
//       const updatedComponents = reusableComponents.map((component) =>
//         component.id === componentId
//           ? { ...component, name: newName }
//           : component
//       );
//       setReusableComponents(updatedComponents);

//       // Find the updated component
//       const updatedComponent = updatedComponents.find(
//         (comp) => comp.id === componentId
//       );

//       // Save the updated component to IndexedDB
//       if (updatedComponent) {
//         await indexedDBService.updateReusableComponent(updatedComponent);
//       }

//       console.log("Renamed reusable component:", componentId, "to", newName);
//     },
//     [reusableComponents]
//   );
//   useEffect(() => {
//     loadReusableComponents();
//   }, [loadReusableComponents]);

//   //to load Demo page if current page is Demo
//   useEffect(() => {
//     if (currentPage && currentPage.name === "Demo") {
//       setShowDemoInstructions(true);
//     } else {
//       setShowDemoInstructions(false);
//     }
//   }, [currentPage]);

//   //to load and save canvasDivisions
//   const loadCanvasDivisions = useCallback(async () => {
//     if (currentPage) {
//       try {
//         const savedDivisions = await indexedDBService.getCanvasDivisions(
//           currentPage.id
//         );
//         if (savedDivisions && savedDivisions.length > 0) {
//           setCanvasDivisions(savedDivisions);
//           setFlatList(generateFlatList(savedDivisions));
//           const allElements = savedDivisions.flatMap((div) =>
//             div.children ? [div, ...div.children] : [div]
//           );
//           globalIdCounter.current =
//             Math.max(
//               ...allElements.map((el) => el.id),
//               globalIdCounter.current
//             ) + 1;
//         } else {
//           console.log(`No saved divisions found for page ${currentPage.id}`);
//           setCanvasDivisions([]);
//           setFlatList([]);
//           // Don't reset globalIdCounter here
//         }
//       } catch (error) {
//         console.error("Error loading canvas divisions:", error);
//       }
//     }
//   }, [currentPage, generateFlatList]);
//   const saveCanvasDivisions = useCallback(async () => {
//     if (currentPage && canvasDivisions.length > 0) {
//       try {
//         await indexedDBService.saveCanvasDivisions(
//           currentPage.id,
//           canvasDivisions
//         );
//         console.log(
//           `Saved ${canvasDivisions.length} divisions for page ${currentPage.id}`
//         );
//       } catch (error) {
//         console.error("Error saving canvas divisions:", error);
//       }
//     }
//   }, [canvasDivisions, currentPage]);
//   useEffect(() => {
//     loadCanvasDivisions();
//   }, [loadCanvasDivisions]);
//   useEffect(() => {
//     const saveTimer = setTimeout(() => {
//       saveCanvasDivisions();
//     }, 500);
//     return () => clearTimeout(saveTimer);
//   }, [canvasDivisions, saveCanvasDivisions]);

//   //to load and save pages
//   const loadPages = useCallback(async () => {
//     let savedPages = await indexedDBService.getPages();
//     if (savedPages && savedPages.length > 0) {
//       setPages(savedPages);

//       const lastActivePageId = localStorage.getItem("lastActivePageId");
//       if (lastActivePageId) {
//         const lastActivePage = savedPages.find(
//           (page) => page.id.toString() === lastActivePageId
//         );
//         if (lastActivePage) {
//           setCurrentPage(lastActivePage);
//           return;
//         }
//       }
//       setCurrentPage(savedPages[0]);
//     } else {
//       const defaultPage = { id: Date.now(), name: "Demo" };
//       setPages([defaultPage]);
//       setCurrentPage(defaultPage);
//       await indexedDBService.savePage(defaultPage);
//     }
//   }, []);
//   const setAndPersistCurrentPage = useCallback((page) => {
//     setCurrentPage(page);
//     localStorage.setItem("lastActivePageId", page.id.toString());
//   }, []);

//   // to load and save preferences(open components and layout options)
//   const loadPreferences = useCallback(async () => {
//     const loadedPrefs = {};
//     for (const key of [...Object.keys(preferences), "LayOut", "isDarkTheme"]) {
//       const value = await indexedDBService.getPreference(key);
//       if (key === "LayOut") {
//         setLayOut(value !== null ? value : 0);
//       } else if (key === "isDarkTheme") {
//         setIsDarkTheme(value !== null ? value : false);
//       } else {
//         loadedPrefs[key] = value !== null ? value : preferences[key];
//       }
//     }
//     setPreferences(loadedPrefs);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);
//   const savePreference = useCallback(async (key, value) => {
//     await indexedDBService.savePreference(key, value);
//     if (key === "isDarkTheme") {
//       setIsDarkTheme(value);
//     } else {
//       setPreferences((prev) => ({ ...prev, [key]: value }));
//     }
//   }, []);
//   const saveLayOut = useCallback(async (value) => {
//     await indexedDBService.savePreference("LayOut", value);
//     setLayOut(value);
//   }, []);
//   useEffect(() => {
//     localStorage.setItem("showGrid", JSON.stringify(showGrid));
//   }, [showGrid]);

//   //useEffect for pages loading and preference loading
//   useEffect(() => {
//     loadPages();
//     loadPreferences();
//   }, [loadPages, loadPreferences]);

//   //add and delete page functions
//   const addPage = async (pageName) => {
//     const newPage = { id: Date.now(), name: pageName };
//     const updatedPages = [...pages, newPage];
//     setPages(updatedPages);
//     await indexedDBService.savePage(newPage);
//   };
//   const deletePage = async (pageId) => {
//     if (pages.length > 1) {
//       const updatedPages = pages.filter((page) => page.id !== pageId);
//       setPages(updatedPages);
//       if (currentPage.id === pageId) {
//         setCurrentPage(updatedPages[0]);
//       }
//       await indexedDBService.deletePage(pageId);
//     }
//   };

//   //for dark/light theme
//   useEffect(() => {
//     document.documentElement.setAttribute(
//       "data-theme",
//       isDarkTheme ? "dark" : "light"
//     );
//     document.body.classList.toggle("dark-theme", isDarkTheme);
//   }, [isDarkTheme]);

//   //to rearrange the items
//   const reorderDivision = useCallback(
//     (id, direction) => {
//       setCanvasDivisions((prevDivisions) => {
//         const reorderRecursive = (divs) => {
//           for (let i = 0; i < divs.length; i++) {
//             if (divs[i].id === id) {
//               if (direction === "up" && i > 0) {
//                 [divs[i - 1], divs[i]] = [divs[i], divs[i - 1]];
//                 return true;
//               } else if (direction === "down" && i < divs.length - 1) {
//                 [divs[i], divs[i + 1]] = [divs[i + 1], divs[i]];
//                 return true;
//               }
//               return false;
//             }
//             if (divs[i].children && divs[i].children.length > 0) {
//               if (reorderRecursive(divs[i].children)) {
//                 return true;
//               }
//             }
//           }
//           return false;
//         };

//         const newDivisions = JSON.parse(JSON.stringify(prevDivisions));
//         reorderRecursive(newDivisions);

//         // Update flatList
//         const newFlatList = generateFlatList(newDivisions);
//         setFlatList(newFlatList);

//         return newDivisions;
//       });
//     },
//     [generateFlatList, setFlatList]
//   );

//   return (
//     <CanvasContext.Provider
//       value={{
//         isDarkTheme,
//         setIsDarkTheme: (value) => savePreference("isDarkTheme", value),
//         canvasDivisions,
//         reloadCanvasDivisions: loadCanvasDivisions,
//         addDivision,
//         addElement,
//         generateFlatList,
//         addCanvasDrop,
//         selectedDivision,
//         setSelectedDivision,
//         flatList,
//         setFlatList,
//         hoveredDivision,
//         setHoveredDivision,
//         deleteDivision,
//         updateDivision,
//         renameDivision,
//         giveIdToDivision,
//         currentPage,
//         setCurrentPage: setAndPersistCurrentPage,
//         pages,
//         showFileManager,
//         setShowFileManager,
//         setPages,
//         addPage,
//         deletePage,
//         createNewProject,
//         showDemoInstructions,
//         setShowDemoInstructions,
//         handleDeleteProject,
//         ...preferences,
//         setShowLeftSidebar: (value) => savePreference("showLeftSidebar", value),
//         setShowRightSidebar: (value) =>
//           savePreference("showRightSidebar", value),
//         setShowLayers: (value) => savePreference("showLayers", value),
//         setShowProperties: (value) => savePreference("showProperties", value),
//         setShowPageManager: (value) => savePreference("showPageManager", value),
//         LayOut,
//         setLayOut: saveLayOut,
//         showGrid,
//         setShowGrid,
//         setFiles,
//         files,
//         isDownloading,
//         setIsDownloading,
//         downloadProgress,
//         updateDownloadProgress,

//         reusableComponents,
//         addReusableComponent,
//         deleteReusableComponent,
//         makeReusable,
//         applyReusableComponent,
//         renameReusableComponent,

//         reorderDivision,
//       }}
//     >
//       {children}
//     </CanvasContext.Provider>
//   );
// };

// export { CanvasContext, CanvasProvider };
